import request from "@/utils/request";
import Qs from "qs";
// 招商投资

// 项目介绍详情
export function get_about() {
  return request({
    url: "/business/get_about",
    method: "get",
  });
}
// 编辑项目介绍
export function save_about(data) {
  return request({
    url: "/business/save_about",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 招商配置详情
export function get_invest() {
  return request({
    url: "/business/get_invest",
    method: "get",
  });
}
// 编辑招商配置
export function save_invest(data) {
  return request({
    url: "/business/save_invest",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区介绍列表
export function project_lists(data) {
  return request({
    url: "/business/project_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加园区介绍
export function add_project(data) {
  return request({
    url: "/business/add_project",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 园区介绍详情
export function project_info(data) {
  return request({
    url: "/business/project_info",
    method: "get",
    params: data,
  });
}
// 编辑园区介绍
export function edit_project(data) {
  return request({
    url: "/business/edit_project",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除园区介绍
export function project_del(data) {
  return request({
    url: "/business/project_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 投资优势列表
export function advantages_lists(data) {
  return request({
    url: "/business/advantages_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
//添加投资优势
export function add_advantages(data) {
  return request({
    url: "/business/add_advantages",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑投资优势
export function edit_advantages(data) {
  return request({
    url: "/business/edit_advantages",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 投资优势详情
export function advantages_info(data) {
  return request({
    url: "/business/advantages_info",
    method: "get",
    params: data,
  });
}
// 删除投资优势
export function advantages_del(data) {
  return request({
    url: "/business/advantages_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加招商政策
export function add_policy(data) {
  return request({
    url: "/business/add_policy",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑招商政策
export function edit_policy(data) {
  return request({
    url: "/business/edit_policy",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 招商政策列表
export function policy_lists(data) {
  return request({
    url: "/business/policy_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
//删除招商政策
export function policy_del(data) {
  return request({
    url: "/business/policy_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 招商政策详情
export function policy_info(data) {
  return request({
    url: "/business/policy_info",
    method: "get",
    params: data,
  });
}

// 招商名片列表
export function card_lists(data) {
  return request({
    url: "/business/card_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加招商名片
export function add_card(data) {
  return request({
    url: "/business/add_card",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 招商名片详情
export function card_info(data) {
  return request({
    url: "/business/card_info",
    method: "get",
    params: data,
  });
}
// 编辑招商名片
export function edit_card(data) {
  return request({
    url: "/business/edit_card",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除招商名片
export function card_del(data) {
  return request({
    url: "/business/card_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 招商l留言列表
export function message_lists(data) {
  return request({
    url: "/business/message_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 招商l留言详情
export function message_info(data) {
  return request({
    url: "/business/message_info",
    method: "get",
    params: data,
  });
}
